import React from 'react';

import ItemsSidebar from "./items";
import LogoImage from "assets/img/logo-icon.png";
import LogoText from "assets/img/logo-text.png";
import {Image} from "react-bootstrap";

const Sidebar = () => {
    return (
        <aside className="main-sidebar sidebar-light-default ">
            <div className="sidebar p-0 d-inline-grid">
                <div className="brand-link py-2 ps-6 border-0 shadow-sm">
                    <Image src={LogoImage} width={35}/>
                    <span className="brand-text font-weight-light ms-2">
                        <Image src={LogoText} width={110} />
                    </span>
                </div>
                <ItemsSidebar />
            </div>
        </aside>
    );
}

export default Sidebar;
